import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "item w-[310px] h-[132px] mr-[20px]"
};
const _hoisted_2 = {
  class: "inner"
};
const _hoisted_3 = {
  class: "opt mt-[20px]"
};
import { onMounted, ref } from "vue";
import { Plus } from "@element-plus/icons-vue";

// eslint-disable-next-line no-undef

export default {
  __name: 'ItemList',
  props: {
    items: {
      type: Array,
      required: true
    },
    gap: {
      type: Number,
      default: 10
    },
    width: {
      type: Number,
      default: 240
    }
  },
  emits: ["add"],
  setup(__props, {
    emit: __emit
  }) {
    // 列表组件
    const props = __props;
    const emits = __emit;
    const containerRef = ref(null);
    const span = ref(12);
    onMounted(() => {
      calcSpan();
    });
    const calcSpan = () => {
      let cols = Math.floor(containerRef.value.offsetWidth / props.width);
      if (cols >= 12) {
        span.value = 1;
        return;
      }
      console.log(cols);
      while (cols > 1) {
        if (24 % cols === 0) {
          span.value = 24 / cols;
          return;
        }
        cols -= 1;
      }
      span.value = 12;
    };
    window.onresize = () => calcSpan();
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock("div", {
        class: "item__list-box",
        ref_key: "containerRef",
        ref: containerRef
      }, [_createVNode(_component_el_row, {
        gutter: __props.gap
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("div", {
          class: "info"
        }, [_createElementVNode("div", {
          style: {
            "color": "var(--theme-text-color-secondary)"
          }
        }, "创建知识库")], -1)), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
          text: "",
          size: "large",
          class: "w-full",
          icon: _unref(Plus),
          onClick: _cache[0] || (_cache[0] = $event => emits('add'))
        }, null, 8, ["icon"])])])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, item => {
          return _openBlock(), _createBlock(_component_el_col, {
            key: item.id,
            span: span.value,
            style: _normalizeStyle({
              marginBottom: __props.gap + 'px'
            })
          }, {
            default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {
              item: item
            })]),
            _: 2
          }, 1032, ["span", "style"]);
        }), 128))]),
        _: 3
      }, 8, ["gutter"])], 512);
    };
  }
};